import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import Header from "@user/components/Header";
import Footer from "@user/components/Footer";
import { HeroAuth } from "@user/components/home/HeroAuth";
import { QuickActions } from "@user/components/home/QuickActions";
import { RecommendedLawyers } from "@user/components/home/RecommendedLawyers";
import { TopicCards } from "@user/components/home/TopicCards";
import { lifecycleState, sortConsults } from "@user/components/UpcomingConsultations";

export default function AuthenticatedHome() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [lawyers, setLawyers] = useState([]);
  const [lawyersLoading, setLawyersLoading] = useState(true);
  const [lawyersError, setLawyersError] = useState(false);
  const [consults, setConsults] = useState([]);
  const [consultsLoading, setConsultsLoading] = useState(true);

  useEffect(() => {
    setLawyersLoading(true);
    setLawyersError(false);
    api.get("/lawyers", { params: { available_only: true } })
      .then((r) => setLawyers((r.data || []).slice(0, 4)))
      .catch(() => { setLawyers([]); setLawyersError(true); })
      .finally(() => setLawyersLoading(false));
  }, []);

  useEffect(() => {
    setConsultsLoading(true);
    api.get("/consultations")
      .then((r) => setConsults(r.data || []))
      .catch(() => setConsults([]))
      .finally(() => setConsultsLoading(false));
  }, []);

  const upcomingConsult = useMemo(() => {
    const relevant = sortConsults(consults).filter(
      (c) => ["live", "upcoming"].includes(lifecycleState(c))
    );
    return relevant[0] || null;
  }, [consults]);

  const onAsk = () => {
    if (query.trim()) sessionStorage.setItem("adv_initial_q", query.trim());
    navigate("/chat");
  };

  const onBook = (lawyer) => navigate(`/book/${lawyer.id}?type=chat`);
  const onViewProfile = (lawyer) => navigate(`/lawyers/${lawyer.id}`);

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex flex-col">
      <Header />
      <main className="flex-1">
        <HeroAuth
          user={user}
          query={query}
          setQuery={setQuery}
          onAsk={onAsk}
          upcoming={upcomingConsult}
          loading={consultsLoading}
        />
        <QuickActions />
        <RecommendedLawyers
          lawyers={lawyers}
          loading={lawyersLoading}
          error={lawyersError}
          onBook={onBook}
          onViewProfile={onViewProfile}
        />
        <TopicCards />
      </main>
      <Footer />
    </div>
  );
}
